"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_758 = exports.Plan_757 = exports.Plan_756 = exports.Plan_755 = exports.Plan_754 = exports.Plan_753 = exports.Plan_752 = exports.Plan_751 = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Plan_751 = exports.Plan_751 = {
  planNumber: 751,
  kindOfCover: "Accident & GVE",
  externalName: "Ultimate",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$1,500",
  petSpecies: [],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3531",
    "excessNo": 3531
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3532",
    "excessNo": 3532
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3533",
    "excessNo": 3533
  }],
  levelsOfCover: [80],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 56,
      "maxAgeDays": 3285,
      "displayValue": "Older than 8 weeks and younger than 9 years"
    },
    "annualLimit": {
      "amount": 20000,
      "formattedAmount": "$20,000",
      "displayValue": "$20,000"
    },
    "skin": true,
    "skinConditions": true,
    "skinConditionsLimit": "$500 sub-limit",
    "paralysisTick": "$1,500 sub-limit",
    "tickParalysis": "$1,500 sub-limit",
    "cruciateLigament": "$2,600 sub-limit",
    "consultationLimit": "$300 sub-limit",
    "consultationsAndVet": "$300 sub-limit",
    "consultationsAndVisits": "$300 sub-limit",
    "consultation": true,
    "emergencyBoardingFees": "$1,500",
    "emergencyBoardingLimit": "$1,500 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["No waiting period for specified accidental injuries.", "30 days for general veterinary expenses."],
      "waitingPeriod": "No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.",
      "itemisedWaitingPeriods": {
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        }
      }
    }
  },
  customCoverDetails: {
    "groomingComplication": true,
    "coversIllness": true,
    "infectiousDisease": true
  },
  isBasePlan: true,
  addOns: []
};
var Plan_752 = exports.Plan_752 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 752,
  externalName: "Ultimate + RC",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3534",
    "excessNo": 3534
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3535",
    "excessNo": 3535
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3536",
    "excessNo": 3536
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$200",
    routineCareLimitBreakDown: [{
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 80
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 80
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 80
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 80
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 80
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }, {
      "description": "HEALTH CHECK",
      "code": "DG02953",
      "limit": 80
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 80
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 80
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "Routine Group",
      "code": "RGBUPA",
      "limit": 200
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for alternative care.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    councilRegistration: false,
    jointSupplements: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["routineCare"],
  isBasePlan: false
});
var Plan_753 = exports.Plan_753 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 753,
  externalName: "Ultimate + AC",
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3537",
    "excessNo": 3537
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3538",
    "excessNo": 3538
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3539",
    "excessNo": 3539
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$1,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "6 months for general veterinary expenses.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses."],
      waitingPeriod: "30 days for alternative care.<br/>6 months for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    oralRinseDrugs: false,
    prescriptionDiet: false,
    routineTeethCleaning: false,
    teethCleaningProducts: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["alternativeCare"],
  isBasePlan: false
});
var Plan_754 = exports.Plan_754 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 754,
  externalName: "Ultimate + MD",
  dental: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3540",
    "excessNo": 3540
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3541",
    "excessNo": 3541
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3542",
    "excessNo": 3542
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: "$500",
    dentalLimitBreakDown: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "180 days for dental illness treatments where selected."],
      waitingPeriod: "30 days for alternative care.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>180 days for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "180 days",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    prescriptionDiet: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["dental"],
  isBasePlan: false
});
var Plan_755 = exports.Plan_755 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 755,
  externalName: "Ultimate + RC + AC",
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3543",
    "excessNo": 3543
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3544",
    "excessNo": 3544
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3545",
    "excessNo": 3545
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: undefined,
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$200",
    routineCareLimitBreakDown: [{
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 80
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 80
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 80
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 80
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 80
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }, {
      "description": "HEALTH CHECK",
      "code": "DG02953",
      "limit": 80
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 80
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 80
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "Routine Group",
      "code": "RGBUPA",
      "limit": 200
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }],
    alternativeCareLimit: "$1,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "No waiting period for routine care where selected."],
      waitingPeriod: "30 days for alternative care.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    oralRinseDrugs: false,
    prescriptionDiet: false,
    routineTeethCleaning: false,
    teethCleaningProducts: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["routineCare", "alternativeCare"],
  isBasePlan: false
});
var Plan_756 = exports.Plan_756 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 756,
  externalName: "Ultimate + RC + MD",
  dental: true,
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3546",
    "excessNo": 3546
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3547",
    "excessNo": 3547
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3548",
    "excessNo": 3548
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: "$500",
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$200",
    routineCareLimitBreakDown: [{
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 80
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 80
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 80
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 80
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 80
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 80
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }, {
      "description": "HEALTH CHECK",
      "code": "DG02953",
      "limit": 80
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 80
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "",
      "code": "",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "Routine Group",
      "code": "RGBUPA",
      "limit": 200
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }],
    alternativeCareLimit: undefined,
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "180 days for dental illness treatments where selected.", "No waiting period for routine care where selected."],
      waitingPeriod: "No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>180 days for dental illness treatments where selected.<br/>No waiting period for routine care where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        dental: {
          "waitTime": "180 days",
          "label": "dental illness treatments where selected"
        },
        routineCare: {
          "waitTime": "No waiting period",
          "label": "routine care where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    prescriptionDiet: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["dental", "routineCare"],
  isBasePlan: false
});
var Plan_757 = exports.Plan_757 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 757,
  externalName: "Ultimate + AC + MD",
  dental: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3549",
    "excessNo": 3549
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3550",
    "excessNo": 3550
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3551",
    "excessNo": 3551
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: "$500",
    dentalLimitBreakDown: undefined,
    routineCareLimit: undefined,
    routineCareLimitBreakDown: undefined,
    alternativeCareLimit: "$1,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "6 months for general veterinary expenses.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "180 days for dental illness treatments where selected."],
      waitingPeriod: "30 days for alternative care.<br/>6 months for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>180 days for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "180 days",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    oralRinseDrugs: false,
    prescriptionDiet: false,
    routineTeethCleaning: false,
    teethCleaningProducts: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["dental", "alternativeCare"],
  isBasePlan: false
});
var Plan_758 = exports.Plan_758 = _objectSpread(_objectSpread({}, Plan_751), {}, {
  planNumber: 758,
  externalName: "Ultimate + RC +AC + MD",
  dental: true,
  routineCare: true,
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 80,
    "excessCode": "3552",
    "excessNo": 3552
  }, {
    "excess": 100,
    "levelOfCover": 80,
    "excessCode": "3553",
    "excessNo": 3553
  }, {
    "excess": 200,
    "levelOfCover": 80,
    "excessCode": "3554",
    "excessNo": 3554
  }],
  limits: _objectSpread(_objectSpread({}, Plan_751.limits), {}, {
    dentalCareLimit: "$500",
    dentalLimitBreakDown: undefined,
    routineCareLimit: "$200",
    routineCareLimitBreakDown: [{
      "description": "TEETH CLEANING",
      "code": "DG02944",
      "limit": 80
    }, {
      "description": "DEWCLAW REMOVAL",
      "code": "DG02940",
      "limit": 80
    }, {
      "description": "PRESCRIPTION DIETS",
      "code": "DG02941",
      "limit": 80
    }, {
      "description": "CREMATION/BURIAL",
      "code": "DG02942",
      "limit": 80
    }, {
      "description": "Routine Group",
      "code": "RG17",
      "limit": 80
    }, {
      "description": "HEARTWORM CONTROL",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "DESEXING",
      "code": "DG02938",
      "limit": 80
    }, {
      "description": "MICROCHIPPING",
      "code": "DG02943",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }, {
      "description": "HEALTH CHECK",
      "code": "DG02953",
      "limit": 80
    }, {
      "description": "VACCINATIONS OR HEALTH CHECKS",
      "code": "DG02932",
      "limit": 80
    }, {
      "description": "FLEA/TICK/WORM CONTROL",
      "code": "DG02937",
      "limit": 80
    }, {
      "description": "OBEDIENCE TRAINING",
      "code": "DG02948",
      "limit": 80
    }, {
      "description": "BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM TEST OR BLOOD SCREEN",
      "code": "DG02934",
      "limit": 80
    }, {
      "description": "HEARTWORM PREVENTATIVE MEDICATION",
      "code": "DG02939",
      "limit": 80
    }, {
      "description": "Routine Group",
      "code": "RGBUPA",
      "limit": 200
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "FFT_OR_URI",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST OR URINALYSIS",
      "code": "DG02955",
      "limit": 80
    }, {
      "description": "FELV/FIV TEST",
      "code": "DG02935",
      "limit": 80
    }, {
      "description": "URINALYSIS",
      "code": "DG02936",
      "limit": 80
    }],
    alternativeCareLimit: "$1,000",
    alternativeCareLimitBreakdown: undefined
  }),
  waitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods), {}, {
    detailed: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed), {}, {
      waitingPeriodMessages: ["30 days for alternative care.", "No waiting period for specified accidental injuries.", "30 days for general veterinary expenses.", "180 days for dental illness treatments where selected."],
      waitingPeriod: "30 days for alternative care.<br/>No waiting period for specified accidental injuries.<br/>30 days for general veterinary expenses.<br/>180 days for dental illness treatments where selected.",
      itemisedWaitingPeriods: _objectSpread(_objectSpread({}, Plan_751.waitingPeriods.detailed.itemisedWaitingPeriods), {}, {
        alternativeCare: {
          "waitTime": "30 days",
          "label": "alternative care"
        },
        dental: {
          "waitTime": "180 days",
          "label": "dental illness treatments where selected"
        }
      })
    })
  }),
  customCoverDetails: _objectSpread(_objectSpread({}, Plan_751.customCoverDetails), {}, {
    afterLifeCare: false,
    alprazolam: false,
    amitriptyline: false,
    behaviouralAssessment: false,
    behaviouralTherapy: false,
    councilRegistration: false,
    desexing: false,
    essentialEuthanasia: false,
    fleaControlDrugs: false,
    fleaTickControlDrugs: false,
    fleaWormDrugs: false,
    heartWormDrugs: false,
    intestinalWormDrugs: false,
    jointSupplements: false,
    microchipping: false,
    oralRinseDrugs: false,
    prescriptionDiet: false,
    routineTeethCleaning: false,
    teethCleaningProducts: false,
    trazodone: false,
    vaccinationCat: false,
    vaccinationDog: false
  }),
  isVariant: true,
  basePlanNo: 751,
  addOns: ["dental", "routineCare", "alternativeCare"],
  isBasePlan: false
});
var _default = exports["default"] = {
  Plan_751: Plan_751,
  Plan_752: Plan_752,
  Plan_753: Plan_753,
  Plan_754: Plan_754,
  Plan_755: Plan_755,
  Plan_756: Plan_756,
  Plan_757: Plan_757,
  Plan_758: Plan_758
};